export const TABLERUN_SIGNUP_PREFILL_EMAIL_KEY = 'tablerun-signup-prefill-email';

export function readAndClearSignupPrefillEmail(): string {
  if (typeof window === 'undefined') return '';
  const email = window.sessionStorage.getItem(TABLERUN_SIGNUP_PREFILL_EMAIL_KEY) ?? '';
  if (email) {
    window.sessionStorage.removeItem(TABLERUN_SIGNUP_PREFILL_EMAIL_KEY);
  }
  return email;
}
